
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import MasterLayout from '@/components/MasterLayout.vue';
import PostHeader from '@/components/NonLoggedInComponents/PostHeader.vue';
import PostIntro from '@/components/NonLoggedInComponents/PostIntro.vue';
import PostInfoHeader from '@/components/NonLoggedInComponents/PostInfoHeader.vue';
import PostInfoImg from '@/components/NonLoggedInComponents/PostInfoImg.vue';
import PostContact from '@/components/NonLoggedInComponents/PostContact.vue';
import PostSpacer from '@/components/NonLoggedInComponents/PostSpacer.vue';
import PostCard from '@/components/NonLoggedInComponents/PostCard.vue';
@Component({
  components: {
    MasterLayout,
    PostHeader,
    PostIntro,
    PostInfoHeader,
    PostInfoImg,
    PostContact,
    PostSpacer,
    PostCard
  }
})
export default class CustomLabels extends Vue {
  $refs!: {
    DefaultActions: HTMLFormElement;
  };
  metaInfo(): any {
    return {
      meta: [
        {
          name: 'description',
          content:
            'Just 1 Label provides custom labels for brands and white-label products. View details about our custom labels and the industries that use the labels we print.'
        }
      ],
      title: 'Custom Labels for Products, Custom Printed Digital Labels'
    };
  }
  /* Properties */
  /* Store Actions */
  /* Watchers */
  /* Data */
  /* Computed */
  /* Async Functions */
  /* Utility Functions */
  /* Loaders */
  /* Mounted */
  /* Created */
  /* Emmited Functions */
}
